import {api} from '../api';
import http from '../http';
import {
  GetTopicDocumentsResponse,
  GetTopicsResponse,
} from '../../interfaces/api/topics';
import {HttpResponse} from '../../interfaces/api/http';

export const topics = {
  getTopics: (
    tabId: number,
    specialtyId: number,
  ): Promise<HttpResponse<GetTopicsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.news.topics}?tab_id=${tabId}&specialty_id=${specialtyId}`;
      http
        .get<GetTopicsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getTopicDocuments: (
    topicId: number,
    specialtyId: number,
  ): Promise<HttpResponse<GetTopicDocumentsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.news.topics}/${topicId}?specialty_id=${specialtyId}`;
      http
        .get<GetTopicDocumentsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
